module.exports = __webpack_public_path__ + "img/error-card.2ed904f.png";